document.querySelectorAll('.OneClickMortgage').forEach((form) => {
    const labels = form.querySelectorAll('.OneClickMortgage__form>label');
    const lines = form.querySelectorAll('.OneClickMortgage__line');

    const allInput = labels[0].querySelector('input');

    const initialPayInput = labels[1].querySelector('input[type=text]');
    const initialPayRange = labels[1].querySelector('input[type=range]');
    const initialPayProc = labels[1].querySelector('.InputBase__unit');

    const termInput = labels[2].querySelector('input[type=text]');
    const betInput = labels[3].querySelector('input[type=text]');

    const sumEl = lines[0].querySelector('div');
    const overpaymentEl = lines[1].querySelector('div');
    const sumAllEl = lines[2].querySelector('div');
    const monthlyPayEl = form.querySelector('.OneClickMortgage__month b');
    const incomeEl = form.querySelector('.OneClickMortgage__month span span');

    form.addEventListener('change', updateSum);

    function getInitialPayProc() {
        return parseFloat(initialPayProc.innerHTML);
    }

    function getValue(input) {
        return input.IMask.typedValue;
    }

    function formatVal(v) {
        return `${Math.round(v).toLocaleString()} ₽`;
    }

    function updateSum() {
        const sum = getValue(allInput) - getValue(initialPayInput);
        const overpayment = sum * getValue(betInput) / 100 * getValue(termInput);
        const sumAll = sum + overpayment;
        const monthlyPay = sumAll / (getValue(termInput) * 12);
        const incomePay = monthlyPay * 2;

        sumEl.innerHTML = formatVal(sum);
        overpaymentEl.innerHTML = formatVal(overpayment);
        sumAllEl.innerHTML = formatVal(sumAll);
        monthlyPayEl.innerHTML = formatVal(monthlyPay);
        incomeEl.innerHTML = formatVal(incomePay);
    }

    labels.forEach((el) => {
        el.querySelector('input[type=text]').IMask.on('accept', updateSum);
    })

    allInput.IMask.on('accept', (e) => {
        const val = getValue(allInput);
        initialPayRange.max = val;
        initialPayInput.IMask.updateOptions({
            max: val,
        });
        initialPayInput.IMask.value = Math.round(val * getInitialPayProc() / 100).toString();
    });

    initialPayInput.IMask.on('accept', (e) => {
        const proc = getValue(initialPayInput) / getValue(allInput) * 100;
        if(!isNaN(proc)) {
            initialPayProc.innerHTML = `${Math.round(proc)}%`;
        }
    })
});
